// frontend/src/components/dashboard/SkeletonTile.tsx
import { Card, Skeleton, Stack } from '@mantine/core';

export function SkeletonTile(): JSX.Element {
  return (
    <Card padding="md" withBorder>
      <Stack gap="xs">
        {/* Label skeleton */}
        <Skeleton height={14} width="60%" radius="sm" />

        {/* Value skeleton */}
        <Skeleton height={28} width="80%" radius="sm" />

        {/* Time ago skeleton */}
        <Skeleton height={12} width="40%" radius="sm" />
      </Stack>
    </Card>
  );
}
